module.exports = __webpack_public_path__ + "static/media/collapse.2e7934c0.svg";